import { EntityCombobox } from "@/components/EntityCombobox";
import { ordemCompraService } from "@/features/compras/services/ordemCompraService";
import type { OrdemCompraResumo } from "@/features/compras/types";

const fmtMoeda = (v: number) => v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

interface OrdemCompraSearchComboboxProps {
  value?: number | null;
  onChange?: (id: number | null) => void;
  onSelect?: (ordem: OrdemCompraResumo | null) => void;
  /** Só POs que ainda podem receber (sem canceladas/totalmente recebidas). Padrão: true. */
  apenasAbertas?: boolean;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  id?: string;
}

/**
 * Pedido de compra por nº ou nome do fornecedor, busca no SERVIDOR
 * (GET /api/compras/ordens?busca=&apenasAbertas=). USA-COM-02.
 */
export function OrdemCompraSearchCombobox({
  apenasAbertas = true, placeholder = "Selecione o pedido de compra...", ...props
}: OrdemCompraSearchComboboxProps) {
  return (
    <EntityCombobox<OrdemCompraResumo>
      {...props}
      queryKey={`ordem-compra-lookup-${apenasAbertas ? "abertas" : "todas"}`}
      buscar={async (termo) =>
        (await ordemCompraService.getAll(1, 20, undefined, { busca: termo || undefined, apenasAbertas })).itens}
      obterPorId={(id) => ordemCompraService.getById(id)}
      getId={(o) => o.id}
      getCodigo={(o) => `PO ${o.numero}`}
      getDescricao={(o) => o.nomeFornecedor ?? "(fornecedor não encontrado)"}
      getExtra={(o) => `${new Date(o.dtEmissao).toLocaleDateString("pt-BR")} · ${fmtMoeda(o.valorTotal)}`}
      placeholder={placeholder}
      placeholderBusca="Buscar por nº da PO ou fornecedor..."
      permitirLimpar
    />
  );
}
